import {callIfFn} from "src/components/Planner/planner/history";
import {
  PlannerAction
} from "src/components/Planner/planner/history/planner-action";
import {ts} from "src/utils/translate"
import {getDeviceById} from "src/components/Planner/planner/uDev";
import {removeTheseDevs} from "src/components/Planner/planner/uDev-dom";
import {PlannerGlobals} from "src/components/Planner/planner/planner-globals";
import {
  placeDevice,
  redrawDevices
} from "src/components/Planner/planner/deviceDrawing";
import $ from "jquery";
import {PLANNER_WIZARD} from "src/components/Planner/planner/wizard";
import {deepCopy} from "src/components/Planner/controller";
import {
  refreshFloorView
} from "src/components/Planner/planner/plannerCacheInvalidation";

export class WizardPlaceAction extends PlannerAction {
  /**
   *
   * @param {number[]} placedDeviceIds
   * @param {CenterGroup[]} centerGroups
   * @param {ConventionalPlacement[]} conventionalPlacements
   */
  constructor(placedDeviceIds, centerGroups, conventionalPlacements) {
    super();
    this.actionName = ts("p_do_action_wiz_use", "Using the Wizard");
    this.placedDeviceIds = placedDeviceIds;
    this.centerGroups = centerGroups;
    this.conventionalPlacements = conventionalPlacements;
  }

  execute(callback) {
    var thisVar = this;
    $('#svgAndChat').addClass('pulsing');

    PLANNER_WIZARD.placedDevIds = [];
    var maxDevId = PLANNER_WIZARD.getBiggestDevId();

    var wasThereProblem = false;
    var centers = [];
    var promises = [];

    this.centerGroups.forEach(function (centerGroup) {
      centerGroup.centers.forEach(function (center) {
        var promise = $.Deferred();
        promises.push(promise);
        centers.push({ center, promise });
      });
    });

    PLANNER_WIZARD.ALL_ELEMS_TO_PLACE = centers.length + this.conventionalPlacements.length;
    PLANNER_WIZARD.PLACED_ELEMS = 0;

    for (var i = 0; i < centers.length; i++) {
      let centerObj = centers[i];
      let oriId = centerObj.center.placedDeviceId;
      placeDevice(centerObj.center.devPlacement[0],
          centerObj.center.devPlacement[1],
          centerObj.center.roomId,
          centerObj.center.dev,
          function (placedDevice) {
            try {
              PLANNER_WIZARD.incrementPlaceds();
              if (!placedDevice) { wasThereProblem = true; }
              else {
                centerObj.center.placedDeviceId = placedDevice.deviceId;
                PlannerGlobals.plannerHistoryManager.deviceIdChanged(oriId, placedDevice.deviceId);
                PLANNER_WIZARD.placedDevIds.push(placedDevice.deviceId);
              }
            } finally {
              centerObj.promise.resolve();
            }
          },
          !centerObj.center.serializable,
          null,
          centerObj.center.devAngle,
          true);
    }

    var conventionalPromise = $.Deferred();
    promises.push(conventionalPromise);

    var conventionalPlacesClone = deepCopy(PLANNER_WIZARD.flattenConvPlacements(this.conventionalPlacements));
    PLANNER_WIZARD.putConvPlacementsNew(this.conventionalPlacements, 0, function () {
      var conventionalPlacesNew = PLANNER_WIZARD.flattenConvPlacements(thisVar.conventionalPlacements);
      conventionalPlacesClone.devs.forEach(function (dev, idx) {
        PlannerGlobals.plannerHistoryManager.deviceIdChanged(dev.deviceId, conventionalPlacesNew.devs[idx].deviceId);
      });
      conventionalPlacesClone.serialIds.forEach(function (id, idx) {
        PlannerGlobals.plannerHistoryManager.serialIdChanged(id, conventionalPlacesNew.serialIds[idx]);
      });
      conventionalPromise.resolve();
    }, function (msg) {
      wasThereProblem = true;
    });

    var speakerGroupPromise = $.Deferred();
    var serialConnectionPromise = $.Deferred();

    $.when.apply($, promises).done(function () {
      PLANNER_WIZARD.createGroups(function () {
        speakerGroupPromise.resolve();
      }, maxDevId);
      PLANNER_WIZARD.createSerialConnections()
      .then(() => {
        serialConnectionPromise.resolve();
      })
      .catch(() => {
        serialConnectionPromise.reject();
      });
    });

    $.when.apply($, promises.concat([speakerGroupPromise, serialConnectionPromise]))
    .always(function () {
      $('#svgAndChat').removeClass('pulsing');
      redrawDevices();
      setTimeout(function () {
        refreshFloorView();
      }, 500);
      callIfFn(callback, true);
    });
  }
  undo(callback) {
    $('#svgAndChat').addClass('pulsing');
    removeTheseDevs(this.placedDeviceIds.map(getDeviceById), () => {
      $('#svgAndChat').removeClass('pulsing');
      redrawDevices();
      callIfFn(callback, true);
      setTimeout(function () {
        refreshFloorView();
      }, 500);
    });
  }
  deviceIdChanged(from, to) {
    for (var i = 0; i < this.placedDeviceIds.length; i++) {
      if (this.equalAsString(this.placedDeviceIds[i], from)) {
        this.placedDeviceIds[i] = to;
        break;
      }
    }
    for (var i = 0; i < this.centerGroups.length; i++) {
      var cg = this.centerGroups[i];
      for (var j = 0; j < cg.centers.length; j++) {
        var c = cg.centers[j];
        if (this.equalAsString(c.placedDeviceId, from)) {
          c.placedDeviceId = to;
          break;
        }
      }
    }
    for (var i = 0; i < this.conventionalPlacements.length; i++) {
      var placement = this.conventionalPlacements[i];
      if (placement.groupWithDevId && this.equalAsString(placement.groupWithDevId, from)) {
        placement.groupWithDevId = to;
        break;
      }
    }
  }
  serialIdChanged(from, to) {
    for (let i = 0; i < this.conventionalPlacements.length; i++) {
      const placement = this.conventionalPlacements[i];
      if (placement.placedSerialId && this.equalAsString(placement.placedSerialId, from)) {
        placement.placedSerialId = to;
      }

      if (placement.targetSerialId && this.equalAsString(placement.targetSerialId, from)) {
        placement.targetSerialId = to;
      }

      if (placement.connToSerId && this.equalAsString(placement.connToSerId, from)) {
        placement.connToSerId = to;
      }
    }
  }
  roomIdChanged(from, to) {
    var thisVar = this;
    this.centerGroups.forEach(function (placement) {
      placement.centers.forEach(function (center) {
        if (thisVar.equalAsString(center.roomId, from)) {
          center.roomId = to;
        }
      });
    });
    this.conventionalPlacements.forEach(function (placement) {
      if (thisVar.equalAsString(placement.room.id, from)) {
        placement.room.id = to;
      }
    });
  }
}
